<div class='overview-container'>
    <app-tooltip
        appCustomPopover
        popoverText='PATIENTS_AND_SERVICES_PATIENT_TASKS_INFO'
        placement='right'
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <div class='overview-item'>
                <span>{{ 'CLIENT_TASKS' | translate }}</span>
                <h1 class='overview-item-text-blue'>{{ totalPatientTasks }}</h1>
            </div>
        </ng-container>
    </app-tooltip>
    <app-tooltip
        appCustomPopover
        popoverText='PATIENTS_AND_SERVICES_PATIENT_TASKS_WITHOUT_MAIN_RESPONSIBLE_INFO'
        placement='top'
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <div class='overview-item'>
                <span>{{ 'TASKS_WITHOUT_MAIN_RESPONSIBLES' | translate }}</span>
                <h1 class='overview-item-text-blue'>{{ tasksWithoutMainResponsibles }}</h1>
            </div>
        </ng-container>
    </app-tooltip>
    @if (totalPatientTasksContainsWarnings > 0) {
        <app-tooltip
            appCustomPopover
            popoverText='PATIENTS_AND_SERVICES_ERRORS_INFO'
            placement='top'
            [adaptPlacement]="true"
        >
            <ng-container icon>
                @if (totalPatientTasksContainsWarnings > 0) {
                    <div class='overview-item'>
                        <span>{{ 'WARNINGS' | translate }}</span>
                        <h1 class='overview-item-text-orange'>{{ totalPatientTasksContainsWarnings }}</h1>
                    </div>
                }
            </ng-container>
        </app-tooltip>
    }
    @if (totalPatientTasksContainsErrors > 0) {
        <app-tooltip
            appCustomPopover
            popoverText='PATIENTS_AND_SERVICES_WARNINGS_INFO'
            placement='top'
            [adaptPlacement]="true"
        >
            <ng-container icon>
                @if (totalPatientTasksContainsErrors > 0) {
                    <div class='overview-item'>
                        <span>{{ 'ERRORS' | translate }}</span>
                        <h1 class='overview-item-text-red'>{{ totalPatientTasksContainsErrors }}</h1>
                    </div>
                }
            </ng-container>
        </app-tooltip>
    }
</div>
